// PSTUDIO-4031: the keys that OPEN edit on a selected, not-yet-editing cell.
//
// Enter (PSTUDIO-2821) and F2 are the same gesture: both mount the editor on the
// committed value with the caret at the end, and neither writes the store (the
// draft is only seeded by a real edit — contract rail 13). Only an UNMODIFIED
// press qualifies: Shift+Enter is the Expanded Cell View shortcut, Ctrl/Cmd/Alt
// chords belong to the browser and the hotkeys layer.
//
// Limitation: this answers "is this key an entry key". Whether the cell may be
// entered at all (text/number kind, exactly one selected cell, not already
// editing) is decided by the caller in `table.tsx`.
export interface EditEntryKeyEvent {
  key: string;
  shiftKey: boolean;
  metaKey: boolean;
  ctrlKey: boolean;
  altKey: boolean;
}

const EDIT_ENTRY_KEYS: ReadonlySet<string> = new Set(['Enter', 'F2']);

export function isEditEntryKey(e: EditEntryKeyEvent): boolean {
  return (
    EDIT_ENTRY_KEYS.has(e.key) &&
    !e.shiftKey &&
    !e.metaKey &&
    !e.ctrlKey &&
    !e.altKey
  );
}
